// apps/api/src/qxcircle/qxcircle-like-notification.ts
// Description: Local like notification payload for QXCircle Slice 17.
// Owner: Masa Bayu
// Date: 2026-08-24

import type { QxCircleNotification } from "./qxcircle.types";

export function createLikeNotification(
  seq: number,
  authorName: string,
  postId: string,
): QxCircleNotification {
  return {
    id: `qxcircle_ntf_like_${seq}`,
    kind: "like",
    title: `Liked ${authorName}'s post`,
    body: "Local notification simulated — not production push.",
    href: `/qxcircle/post/${encodeURIComponent(postId)}`,
    read: false,
    createdAt: new Date().toISOString(),
  };
}
